import {connect, useSelector} from "react-redux";

import {AgGridReact} from "ag-grid-react";
import {Loading} from "../../../components/common";
import * as common from "../common/common";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
	CAlert,
	CButton,
	CCol,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
	CNav, CNavItem, CNavLink,
	CRow, CTabContent, CTabPane
} from "@coreui/react";
import CmpListWhere from "../where/CmpListWhere";
import BrandListWhere from "../where/BrandListWhere";
import StoreListWhere from "../where/StoreListWhere";

import SubBrandListWhere from "../where/SubBrandListWhere";
import SubStoreListWhere from "../where/SubStoreListWhere";

import {getPosUserListByStore, insertCkProductInfo, putPosUser, getUserList} from "../../../api/api";
import sha256 from "sha256";
import * as o2Api from "../../../api/api";
import StoreDetail from "../store/StoreDetail";
import StoreCorner from "../store/StoreCorner";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const PosUser = (props) => {
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const gridRef = useRef();
	const {user} = useSelector((props) => props.account);

	const [activeKey, setActiveKey] = useState(1)

	const [loading, setLoading] = useState(false);
    const [cmpLoading, setLoadingCmp] = useState(false);
    const [brandLoading, setLoadingBrand] = useState(false);
    const [storeLoading, setLoadingStore] = useState(false);
    const [initCheck, setInitCheck] = useState(false);

    const [company, setCompany] = useState([{ cmpCd: "", cmpNm: "전체" }]);
    const [brand, setBrand] = useState([{ brandCd: "", brandNm: "전체" }]);
    const [store, setStore] = useState([{ storeCd: "", storeNm: "전체" }]);
    const [selected, setSelected] = useState({
        cmpCd: "", brandCd: "", storeCd: ""
    });

	const [rowData, setRowData] = useState([]);
	const [error, setError] = useState({visible: false, message: ""});

	const [menuData, setMenuData] = useState([]);

	const [searchForm, setSearchForm] = useState({
		cmpCd: "",
		brandCd: "",
		storeCd: "",
		schUserNm: "",
		schUserId: ""
	});

    const [authority, setAuthority] = useState([{
        cmpCd: "",
		brandCd: "",
		storeCd: "",
		etc1Char: "",
		codeNm: "",
		authority: ""
    }]);

    const [userId, setUserId] = useState("");
	const [formData, setFormData] = useState({useYn: "Y"});

    useEffect(() => {
        let subCode  = "";
        //console.log("user.authority:: ", user.authority);

        switch (user.authority) {
            case "ROLE_CENTER_ADMIN":
                subCode = "0000";
                break;
			case "ROLE_CENTER_MANAGER":
				subCode = "0100";
				break;
            case "ROLE_COMPANY_ADMIN":
                subCode = "1000";
                break;
            case "ROLE_BRAND_ADMIN":
                subCode = "2000";
                break;
			case "ROLE_BRAND_MANAGER":
				subCode = "2100";
				break;
            case "ROLE_STORE_ADMIN":
                subCode = "3000";
                break;
            case "ROLE_STORE_MANAGER":
                subCode = "3100";
                break;
        }

        getAuthority(subCode);
    }, []);

	const defaultColDef = {
		flex: 1,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [columnDefs] = useState([
        {field: 'seq', headerName: 'seq', hide:true},
        {field: 'cmpCd', headerName: '운영사', hide:true},
        {field: 'brandCd', headerName: '휴게소', hide:true},
        {field: 'brandNm', headerName: '휴게소명', width: 120},
        {field: 'storeCd', headerName: '점포', hide:true},
        {field: 'storeNm', headerName: '점포명', width: 120},
        {field: 'userNm', headerName: '사원명', width: 120},
		{field: 'userId', headerName: '사용자ID', width: 120},
	]);

	const [menuColumnDefs] = useState([
		{field: 'menuNm', headerName: "메뉴목록"},
		{field: 'isUse', headerName: "선택"}
	]);

    const getAuthority = (subCode) => {

        setLoading(true);

        const params = {
            subCode: subCode
        };

        o2Api.getAuthority(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            console.log("### response :: ", responseBody);
            if (responseCode === "200") {

            	//console.log("responseBody::: ", [responseBody]);
                setLoading(false);

                let userAuthority = responseBody[0].etc1Char;
				formData.authority = responseBody[0].etc1Char;

                initSelect(userAuthority);


                setAuthority(responseBody);

            } else {
                setLoading(false);
            }
        });

    }

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	};

	const search = () => {
		setError({visible: false, message: ""});
		const {cmpCd, brandCd, storeCd} = searchForm;
		if (cmpCd.length === 0) {
			setError({
				visible: true,
				message: "운영사 정보를 선택해주세요."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
            userNm: searchForm.schUserNm,
			userId: searchForm.schUserId

        }
        //console.log("조회 시 params ::", params);

        setLoading(true);
        getUserList(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			if (responseCode === "200") {
				// 성공
				console.log(">>> response :: ", responseBody);
				setRowData(responseBody);

			} else {
				setError({visible: true, message: responseMessage});
			}
		})
		.catch((e) => {
			setError({visible: true, message: e.message});
		})
		.finally(() => {
			setLoading(false);
		})
	}

	const init = () => {

		setFormData({
			seq: -1,
			cmpCd: "",
            cmpNM: "",
			brandCd: "",
            brandNm: "",
			storeCd: "",
            storeNm: "",
			userId: "",
			userNm: "",
			password: "",
			authority: authority[0].etc1Char, //ROLE_STORE_ADMIN
			passwordCheck: "",
			posUserId: "",
			posPassword: "",
			posPasswordCheck: "",
			telNo: "",
			useYn: "Y"
		});

		//신규 등록
        setInitCheck(false);
        initSelect(authority[0].etc1Char);

	} //End init;

    const initSelect = (data) => {

		const authority = data;
		console.log("initSelect 펑션에서 권한 ::  ", authority);

		if(authority === "ROLE_COMPANY_ADMIN") {
			setLoadingCmp(true);
			setLoadingBrand(false);
			setLoadingStore(false);
        } else if (authority === "ROLE_BRAND_ADMIN" || authority === "ROLE_BRAND_MANAGER") {
			setLoadingCmp(false);
			setLoadingBrand(true);
			setLoadingStore(false);
        } else if (authority === "ROLE_STORE_ADMIN" || authority === "ROLE_STORE_MANAGER" ) {
			setLoadingCmp(false);
			setLoadingBrand(false);
			setLoadingStore(true);
		} else { //시스템관리자
			setLoadingCmp(false);
			setLoadingBrand(false);
			setLoadingStore(false);
        }

    } //End initSelect

	const save = () => {

		let cmpCd = "";
        let brandCd = "";
        let storeCd = "";

        const { api } = gridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        //console.log('저장 시 선택 selectRows :: ', selectRows);
        console.log('저장 시 선택 formdata :: ', formData);


        if (initCheck) {
        	//cmpCd = selectRows[0].cmpCd;
            //brandCd = selectRows[0].brandCd;
            //storeCd = selectRows[0].storeCd;
            cmpCd = formData.cmpCd;
            brandCd = formData.brandCd;
            storeCd = formData.storeCd;
        } else{
            cmpCd = props.selected.cmpCd;
            brandCd = props.selected.brandCd;
            storeCd = props.selected.storeCd;
		}

        if (confirm("저장하시겠습니까?")) {
            //console.log("저장 시 props.selected :: ", props.selected);
            //console.log("저장 시 formData :: ", formData);

			if (formData.authority ==='ROLE_STORE_ADMIN'  ) {
				if(storeCd.length === 0){
					setError({
						visible: true,
						message: "점포 점주 등록시 매장은 반드시 선택하셔야 합니다."
					});
                    return;
                }
            } else if (formData.authority ==='ROLE_STORE_MANAGER') {
				if(storeCd.length === 0 ) {
					setError({
						visible: true,
						message: "점포 직원 등록시 매장은 반드시 선택하셔야 합니다."
					});
					return;
                }
            } else if (formData.authority ==='ROLE_BRAND_ADMIN' || formData.authority ==='ROLE_BRAND_MANAGER') {
				//storeCd === "";
				if(brandCd.length === 0 ){
					setError({
						visible: true,
						message: "휴게소관리자 등록 시, 휴게소는 반드시 선택하셔야 합니다."
					});
					return;
                }
            } else if (formData.authority ==='ROLE_COMPANY_ADMIN') {
				//brandCd === "";
                //storeCd === "";
				if(cmpCd.length === 0) {
					setError({
						visible: true,
						message: "운영사관리자 등록 시, 운영사는 반드시 선택하셔야 합니다."
					});
					return;
                }
            }

			// 비밀번호 입력 확인 처리
			console.log(">>> passworkd :: ", formData.password);
			if (formData.password !== undefined) {
				if (formData.password !== formData.passwordCheck) {
					setError({
						visible: true,
						message: "비밀번호를 다시 확인해주세요."
					});
					return;
				}
			}
			else {
				setError({
					visible: true,
					message: "비밀번호는 필수 입력입니다."
				});
				return;
			}

			if (formData.posPassword !== formData.posPasswordCheck) {
				setError({
					visible: true,
					message: "POS 비밀번호를 다시 확인해주세요."
				});
				return;
			}

			// 저장 파라메터 생성
			if (formData.seq === -1) {
				delete formData.seq;
			}

			// 비밀번호 sha256 처리
			if (formData.password.length < 64) {
				formData.password = sha256(formData.password);
			}

            formData.cmpCd = cmpCd;
            formData.brandCd = brandCd;
            formData.storeCd = storeCd;

            const userInfo = {
				...formData,
				instUser: formData.instUser ? formData.instUser : user.userId,
				updUser: user.userId,
			}
			//console.log(">>> 저장 직전 params :: ", userInfo);

			setLoading(true);
			putPosUser(userInfo).then((result) => {
				const {responseBody, responseCode, responseMessage} = result.data;
				if (responseCode === "200") {
					// 성공
					alert("정상적으로 처리되었습니다.");
                    setError({visible: false, message: ""});
					search();
				} else {
					setError({visible: true, message: responseMessage});
				}
			})
			.catch((e) => {
				setError({visible: true, message: e.message});
			})
			.finally(() => {
				setLoading(false);
			})
		}
	}

	const onRowSelected = useCallback((event) => {

        if (!event.node.selected)
			return;

        setLoadingCmp(false);
        setLoadingBrand(false);
        setLoadingStore(false);
        setInitCheck(true);

		const data = event.node.data;

		data.seq = data.seq;
        data.cmpCd = data.cmpCd;
        data.cmpNm = data.cmpNm;
        data.brandCd = data.brandCd;
        data.brandNm = data.brandNm;
        data.storeCd = data.storeCd;
        data.storeNm = data.storeNm;
        data.authority = data.authority;
        data.etc1Char = data.authority;
        data.useYn = data.useYn;
        data.passwordCheck = data.password;
		data.posPasswordCheck = data.posPassword;

        //initSelect(data.authority);

        setSearchForm({
            cmpCd : data.cmpCd,
            brandCd : data.brandCd,
            storeCd : data.storeCd
		});

        setFormData(data);

    }, []);

	return (
		<>
			<div style={containerStyle}>
				{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
				{loading ? <Loading/> : null}
				<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
					<h5>매장 사용자 관리</h5>
					<CButton color="dark" onClick={search}>조회</CButton>
				</div>
				<CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
					<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
									onSelect={(c, v) => handleSelect(c, v)}/>

					<CCol xs={12}>
						<CInputGroup size={"sm"} className={"mb-1"} style={{height: 35}}>
							<CInputGroupText style={{width: 100}}>사원명</CInputGroupText>
							<CFormInput id="schUserNm"
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                schUserNm: e.target.value
                                            }));
                                        }}
                            />
						</CInputGroup>
					</CCol>
					<CCol xs={12}>
						<CInputGroup size={"sm"} className={"mb-1"} style={{height: 35}}>
							<CInputGroupText style={{width: 100}}>사원아이디</CInputGroupText>
							<CFormInput id="schUserId"
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                schUserId: e.target.value
                                            }));
                                        }}
                            />
						</CInputGroup>
					</CCol>
				</CForm>
				<div style={{height: 10}}/>
				<CRow>
					<CCol xs={5}>
						<div className="ag-theme-alpine" style={{width: "100%", height: 450, marginTop: 10}}>
							<AgGridReact
                                ref={gridRef}
								rowSelection={'single'}
								headerHeight={30}
								rowHeight={30}
								onRowClicked={onRowSelected}
								rowData={rowData}
								defaultColDef={defaultColDef}
								columnDefs={columnDefs}>
							</AgGridReact>
						</div>
					</CCol>
					<CCol xs={7}>
						<CNav variant="tabs" role="tablist">
							<CNavItem>
								<CNavLink
									active={activeKey === 1}
									onClick={() => setActiveKey(1)}>사용자 정보</CNavLink>
							</CNavItem>
							<CNavItem>
								<CNavLink
									active={activeKey === 2}
									onClick={() => setActiveKey(2)}>권한 설정</CNavLink>
							</CNavItem>
						</CNav>
						<CTabContent>
							<CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
								<div style={{height: 10}}/>

								<div className="d-grid gap-1 d-md-flex justify-content-between align-items-center"
									 style={{
										 borderRadius: 5,
										 padding: 10,
										 marginTop: 10,
										 marginBottom: 10,
										 background: "#87CEFA"
									 }}>
									<strong>매장 사용자 정보</strong>
									<CButton size={"sm"} onClick={init}>신규</CButton>
								</div>
								<CForm className="row g-2">


									{cmpLoading &&
									<CmpListWhere id="cmp" account={props.account} selected={searchForm}
												  onSelect={(c, v) => handleSelect(c, v)}/>
									}
									{brandLoading &&
									<SubBrandListWhere id="brand" account={props.account} selected={searchForm}
													   onSelect={(c, v) => handleSelect(c, v)}/>
									}
									{storeLoading &&
									<SubStoreListWhere id="store" account={props.account} selected={searchForm}
													   onSelect={(c, v) => handleSelect(c, v)}/>
									}

									{ initCheck &&
									<CRow >
										<CCol xs={4}>
											<CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
												<CInputGroupText style={{width: 80}}>운영사</CInputGroupText>
												<CFormInput id="company" name="company"
															disabled={true}
															value={formData.cmpNm}
															onChange={(e) => {
																setFormData((state) => ({
																	...state, cmpNm: e.target.value
																}))
															}}/>
											</CInputGroup>
										</CCol>

										<CCol xs={4}>
											<CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
												<CInputGroupText style={{width: 80}}>휴게소</CInputGroupText>
												<CFormInput id="brand" name="brand"
															disabled={true}
															value={formData.brandNm}
															onChange={(e) => {
																setFormData((state) => ({
																	...state, brandNm: e.target.value
																}))
															}}/>
											</CInputGroup>

										</CCol>
										<CCol xs={4}>
											<CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
												<CInputGroupText style={{width: 80}}>매장</CInputGroupText>
												<CFormInput id="store" name="store"
															disabled={true}
															value={formData.storeNm}
															onChange={(e) => {
																setFormData((state) => ({
																	...state, storeNm: e.target.value
																}))
															}}/>
											</CInputGroup>
										</CCol>
									</CRow>
									}

									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>사원번호/명</CInputGroupText>
											<CFormInput id="user"
														disabled={true}
														value={formData.seq}/>
											<CFormInput id="userNm"
														value={formData.userNm}
														onChange={(e) => {
															setFormData((state) => ({
																...state, userNm: e.target.value
															}))
														}}/>
										</CInputGroup>
									</CCol>
									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>권한</CInputGroupText>
											<CFormSelect id="authority" disabled={initCheck}
														 value={formData.authority}  /*authority.etc1Char*/
														 onChange={(e) => {
															 setFormData((state) => ({
																 ...state,
																 authority: e.target.value
															 }))
															 initSelect(e.target.value);
														 }}>

												{authority.map((item, index) => {
													return (
														<option key={index} value={item.etc1Char}>{item.codeNm}</option>
													);
												})}
											</CFormSelect>
										</CInputGroup>
									</CCol>



									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>사용자ID</CInputGroupText>
											<CFormInput id="userId"
														value={formData.userId}
														onChange={(e) => {
															setFormData((state) => ({
																...state, userId: e.target.value
															}))
														}}/>
										</CInputGroup>
									</CCol>
									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>비밀번호</CInputGroupText>
											<CFormInput id="password"
														type={"password"}
														value={formData.password}
														onChange={(e) => {
															setFormData((state) => ({
																...state, password: e.target.value
															}))
														}}/>
											<CFormInput id="passwordCheck"
														type={"password"}
														placeholder={"확인"}
														value={formData.passwordCheck}
														onChange={(e) => {
															setFormData((state) => ({
																...state, passwordCheck: e.target.value
															}))
														}}/>
										</CInputGroup>
									</CCol>
									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>판매POS ID</CInputGroupText>
											<CFormInput id="posUserId"
														value={formData.posUserId}
														onChange={(e) => {
															setFormData((state) => ({
																...state, posUserId: e.target.value
															}))
														}}/>
										</CInputGroup>
									</CCol>
									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>POS비밀번호</CInputGroupText>
											<CFormInput id="posPassword"
														type={"password"}
														value={formData.posPassword}
														onChange={(e) => {
															setFormData((state) => ({
																...state, posPassword: e.target.value
															}))
														}}/>
											<CFormInput id="posPasswordCheck"
														type={"password"}
														placeholder={"확인"}
														value={formData.posPasswordCheck}
														onChange={(e) => {
															setFormData((state) => ({
																...state, posPasswordCheck: e.target.value
															}))
														}}/>
										</CInputGroup>
									</CCol>
									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>연락처</CInputGroupText>
											<CFormInput id="telNo"
														maxLength={11}
														value={formData.telNo}
														onChange={(e) => {
															setFormData((state) => ({
																...state, telNo: e.target.value
															}))
														}}
											/>
										</CInputGroup>
									</CCol>
									<CCol xs={6}/>
									<CCol xs={6}>
										<CInputGroup className={"mb-1"} size={"sm"}>
											<CInputGroupText style={{width: 100}}>사용유무</CInputGroupText>
											<CFormSelect id={"useYn"}
														 value={formData.useYn}
														 onChange={(e) => {
															 setFormData((state) => ({
																 ...state,
																 useYn: e.target.value
															 }));
														 }}>
												<option value={"Y"}>사용</option>
												<option value={"N"}>미사용</option>
											</CFormSelect>
										</CInputGroup>
									</CCol>

									{/*삭제*/}

									<div style={{height: 10}}/>
									<div className={"d-grid gap-2"}>
										<CButton onClick={save}>저장</CButton>
									</div>
								</CForm>

							</CTabPane>
							<CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>

							</CTabPane>
						</CTabContent>
					</CCol>
				</CRow>
			</div>
		</>
	)
}


const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(PosUser);
